
/**
 * Cast value as observable, if it already is then just return otherwise wrap it in an observable
 */
ko.asObservable = function(value) {
  if (ko.isObservable(value)) {
    return value;
  } else {
    return ko.observable(value);
  }
};


/**
 * Cast value as observableArray, if it already is then just return otherwise wrap it in an observableArray
 */

ko.asObservableArray = function(value) {
  if (ko.isObservable(value)) {
    return value;
  } else {
    return ko.observableArray(value);
  }
};
